import * as React from 'react';
import { Filter } from '../../../store/Models/Filter';

interface FiltersContainerProps {
    filters: Filter[];
    getFriendlyNameForFilter: (filter: Filter) => string;
    removeFilter_click: (filter: Filter) => void;
    skipFilterIds?: string[]; // when set, the given filter ids will not be rendered
}

export default class FiltersContainer extends React.PureComponent<FiltersContainerProps > {
    public render() {
        const skipFilterIds = this.props.skipFilterIds ?? [];

        return (
            <div className="active-filters-container">
                <div className="active-filter-values-container">
                    {this.props.filters.filter(f => !skipFilterIds.includes(f.filterId)).map((filter, index) => (
                    <div key={index} className="active-filter-value">
                        <span>{this.props.getFriendlyNameForFilter(filter)}</span>
                        {" "}
                        <span className="remove-filter-value-button" onClick={e => this.props.removeFilter_click(filter)}>x</span>
                    </div>
                ))}
                </div>
            </div>
        );
    }
}